import type { GuestCard } from './screen-handle';

/** T3 카드 폭 — 토큰에 없는 T3 전용 치수(DD-14 Q1). 인라인 style. none 은 내용 크기 그대로 */
export const GUEST_CARD_WIDTH_PX: Record<GuestCard, number | undefined> = {
  login: 900,
  narrow: 600,
  none: undefined,
};

/** 헤더 검색: 이 글자 수부터 찾는다(GlobalSearchPanel 안내 "2글자 이상") */
export const SEARCH_MIN_LENGTH = 2;
/** 헤더 검색: 입력이 이만큼 멈추면 요청한다(코드 값) */
export const SEARCH_DEBOUNCE_MS = 300;
